import { ActionType } from '@/types/actionType';
import { LOG_OUT } from '../auth/actionTypes';
import {
	CLEAN_REDUCER,
	END_FETCH_MAP_DEVICES,
	FETCH_DEVICE_COMMANDS,
	FETCH_MAP_DEVICES,
	FETCH_SELECTED_DEVICE,
	INIT_FETCH_MAP_DEVICES,
	TOGGLE_OTHER_UNITS,
	TOGGLE_REFRESH,
	UPDATE_MAP_DEVICES,
} from './actionTypes';

const initState = {
	devices: [],
	deviceCommands: [],
	selectedDevice: 0,
	otherUnits: true,
	refresh: true,
	loadingDevices: false,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case INIT_FETCH_MAP_DEVICES:
			return {
				...state,
				selectedDevice: 0,
				loadingDevices: true,
			};
		case END_FETCH_MAP_DEVICES:
			return {
				...state,
				loadingDevices: false,
			};
		case TOGGLE_OTHER_UNITS:
			return {
				...state,
				otherUnits: action.otherUnits,
			};
		case TOGGLE_REFRESH:
			return {
				...state,
				refresh: action.refresh,
			};
		case UPDATE_MAP_DEVICES:
		case FETCH_MAP_DEVICES:
			return {
				...state,
				devices: action.devices,
			};
		case FETCH_DEVICE_COMMANDS:
			return {
				...state,
				deviceCommands: action.deviceCommands,
			};
		case FETCH_SELECTED_DEVICE:
			return {
				...state,
				selectedDevice: action.selectedDevice,
				loadingDevices: false,
			};
		case ActionType.UPDATE_DEVICE:
			return {
				...state,
				devices: state.devices.map((device) => {
					return device.id === action.payload.id ? action.payload : device;
				}),
			};
		case CLEAN_REDUCER:
		case LOG_OUT:
			return initState;
		default:
			return state;
	}
};

export default reducer;
